import { StorySlide } from '../types/interfaces';
import { apiGet, apiPatch } from '../utils/api';

export const getMyStorySlides = (): Promise<StorySlide[]> =>
  apiGet<StorySlide[]>('/tipsters/me/story-slides');

export const markSlideSeen = (slideId: number): Promise<{ ok: boolean }> =>
  apiPatch<{ ok: boolean }>(`/tipsters/me/story-slides/${slideId}/seen`);
